module.exports = __webpack_public_path__ + "static/media/swingDividingPatterns.aefa80a6.png";